import { Link } from 'react-router-dom';

const events = [
  {
    id: 'e1',
    day: '11',
    month: 'Jul',
    meta: 'Workshop - Paid',
    title: 'Agentic Development',
    description: "The opener to July's Agentic Stack series. Architect, build and ship AI agents that hold up in production - not just in a demo.",
    format: 'Jul 11\u201312 \u00b7 \u20b93,000',
  },
  {
    id: 'e2',
    day: '15',
    month: 'Jul',
    meta: 'Intro Session - Free',
    title: 'Autonomous Agents with Azure AI Foundry',
    description: "A free intro to building autonomous agents on Azure AI Foundry. See what's possible before you commit to the paid series.",
    format: 'Online - Free',
  },
  {
    id: 'e3',
    day: '18',
    month: 'Jul',
    meta: 'Workshop - Paid',
    title: 'Agentic QA',
    description: 'Bring agentic workflows to testing. Automate QA with AI agents that catch what manual passes miss.',
    format: 'Jul 18-19 - \u20b93,000',
  },
];

function HomeEventsSection() {
  return (
    <section className="band bg-light" id="events" aria-labelledby="events-title">
      <div className="wrap">
        <div className="head-block center">
          <p className="eyebrow">Live Events - July 2026</p>
          <h2 className="section-title" id="events-title" style={{ marginTop: '12px' }}>
            Upcoming <span className="red">Events</span>
          </h2>
          <p className="section-sub">Hands-on workshops and free intro sessions, led personally by Chaitanya. Start free, go deep when you&#39;re ready - no recordings, no avatars.</p>
        </div>

        <div className="event-grid" style={{ marginTop: '38px' }}>
          {events.map((event) => (
            <article className="event-card" key={event.id}>
              <div className="event-top">
                <div className="event-date">
                  <div className="d">{event.day}</div>
                  <div className="m">{event.month}</div>
                </div>
                <div>
                  <div className="event-meta">{event.meta}</div>
                  <h4>{event.title}</h4>
                </div>
              </div>
              <div className="event-body">
                <p>{event.description}</p>
                <div className="event-foot">
                  <span className="fmt">{event.format}</span>
                  <Link className="btn btn-red btn-sm" to="/events">Register</Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="center" style={{ marginTop: '44px' }}>
          <Link className="btn btn-red btn-pill" to="/events">View All Events</Link>
        </div>
      </div>
    </section>
  );
}

export default HomeEventsSection;
